/*components */
export const DASHBOARD_SET_WORKER_CONTEXT = 'DASHBOARD_SET_WORKER_CONTEXT';
export const DASHBOARD_SET_WORKER_CONTEXT_ONLY = 'DASHBOARD_SET_WORKER_CONTEXT_ONLY';
export const DASHBOARD_SET_WORKER_CONTEXT_SUCCESS = 'DASHBOARD_SET_WORKER_CONTEXT_SUCCESS';
export const DASHBOARD_SELECT_MENU = 'DASHBOARD_SELECT_MENU';
export const DASHBOARD_RESET = 'DASHBOARD_RESET';